<p-dialog
  [contentStyle]="{ overflow: 'auto', 'max-height': '60vh', 'min-height': '50vh' }"
  [styleClass]="'sm:col-12 md:col-12 lg:col-9 xl:col-6'"
  [dismissableMask]="false"
  modal="true"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="close()"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Query_List_1' | translate}}
    </span>
  </ng-template>
  <div class="col-12 lg:col-12 md:col-12">
    <div class="scroll-table">
      <p-table
        #dt
        [selectionMode]="'single'"
        [columns]="listColumnsRequest"
        [value]="requests"
        [paginator]="false"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        (onRowSelect)="showDetails($event)"
        (onRowUnselect)="unSelect()"
        (onFilter)="setFilteredList($event)"
        >
        <ng-template pTemplate="caption">
          <span class="header-grid-wrapper">
            <span class="align-right">{{'Tot' | translate}} {{ requests.length }} {{'Query_1' | translate}}</span>
          </span>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th [pSortableColumn]="columns[0].field" class="width-auto">
              <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{ columns[0].header }}
              <input
                (click)="$event.stopPropagation()"
                pInputText
                type="text"
                (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                style="color: darkgrey;"
                />
              </th>
              <th [pSortableColumn]="columns[1].field" class="width-auto">
                <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{ columns[1].header }}
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                  style="color: darkgrey;"
                  />
                </th>
                <th style="width: 3em"></th>
              </tr>
            </ng-template>
            <ng-template let-rowData let-columns="columns" pTemplate="body">
              <tr [pSelectableRow]="rowData">
                <td class="width-auto">
                  {{ rowData[columns[0].field] }}
                </td>
                <td class="width-auto">
                  {{ rowData[columns[1].field] }}
                </td>
                <th>
                  <i
                    class="icons8-trash-can iconstyle"
                    (click)="deleteRequest($event, rowData)"
                    style="color:red;"
                  ></i>
                </th>
              </tr>
            </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">{{'Empty' | translate}}</td>
          </tr>
        </ng-template>
          </p-table>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [contentStyle]="{ overflow: 'inherit' }"
      header="{{'Query_4_Req' | translate}}"
      modal="modal"
      [(visible)]="displayUpdate"
      [closable]="true"
      (onHide)="closeDia($event)"
      width="600"
      >
      @if (displayUpdate) {
        <div class="grid">
          <div class="col-12">
            <span class="p-float-label size_cent">
              <input
                pInputText
                [(ngModel)]="labelRequest"
                autoFocus
                name="labelRequest"
                class="p-inputtext size_cent"
                type="text"
                />
                <label>{{'Col_Inti' | translate}} *</label>
              </span>
            </div>
            <div class="col-12"></div>
            <div class="col-12 md:col-12 align-right">
              <button class="margin p-button-primary p-button-outlined" type="button" pButton (click)="displayUpdate = false" label="{{'Cancel' | translate}}"></button>
              <button class="margin" type="button" pButton (click)="validRequest()" label="{{'Valid' | translate}}"></button>
            </div>
          </div>
        }
      </p-dialog>

      <app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
